import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteMicrosite} from 'src/openapi/admin/apis/MicroSitesBaseInfoApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveMicrosite = ({accountId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        deleteMicrosite({accountId}),
    ), [accountId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
